import {useEffect, useState} from "react";
import {Box, IconButton, styled, Typography, useMediaQuery} from "@mui/material";
import useThemeStore from "../../store/theme";
import {CloseRounded} from "@mui/icons-material";
import {AnimatePresence, motion} from "framer-motion";
import {Link} from "react-router-dom";

const DownloadPopup = () => {

    const [closed, setClosed] = useState(true);
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
    const themeMode = useThemeStore(state => state.mode);

    function handleClose(e) {
        e?.stopPropagation();
        e?.preventDefault();
        setClosed(true);
        localStorage.setItem('dl_popup', '1');
    }

    useEffect(() => {
        const isClosedBefore = Boolean(localStorage.getItem('dl_popup'));
        if (!isClosedBefore) {
            setClosed(false);
        }
    }, []);

    return (
       <AnimatePresence>
           {isMobile && !closed
               ?
               <Link to="/download">
                   <Wrapper
                       onClick={(e) => handleClose()}
                       component={motion.div}
                       initial={{ opacity: 0, y: 200 }}
                       animate={{ opacity: 1, y: 0 }}
                       exit={{ opacity: 0, y: 200 }}
                       sx={{ background: themeMode === "dark" ? "#f5f5f5" : "#424242", color: themeMode === "dark" ? "#212121" : "#fff" }}>
                       <Box component="img" src="/assets/image/logo/logo.jpg" width={32} height={32}/>
                       <Typography ml={1} fontSize=".975rem" fontWeight={500}>همین حالا اپ میلفا رو برای گوشیت نصب کن!</Typography>
                       <IconButton onClick={handleClose} color="inherit">
                           <CloseRounded/>
                       </IconButton>
                   </Wrapper>
               </Link>
           : null}
       </AnimatePresence>
    )
}

const Wrapper = styled(Box)(({theme}) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    padding: 24,
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
    zIndex: 1299,
}));

export default DownloadPopup;